// extracted by mini-css-extract-plugin
export var customeTheme = "styles-module--customeTheme--14UZV";
export var placeTop = "styles-module--place-top--3itNm";